import { useQuery } from '@tanstack/react-query';
import { FreelancerService } from '../../services/freelancer';
import { IBaseUseQueryProps } from '../../interfaces/baseUseQueryProps';
import { IBlobResponse } from '../../interfaces/blobResponse';

interface IProps extends IBaseUseQueryProps<IBlobResponse>{
  userId: number;
  certId: string;
}

export const useGetFreelancerCertificate = ({userId, certId, ...props}: IProps) => useQuery({
  queryKey: ['certificate-entity'],
  queryFn: () => FreelancerService.getCertificate(userId, certId),
  enabled: !!certId,
  refetchOnWindowFocus: false,
  ...props
});